import { GetUserInfoDto } from "../../dtos/user/GetUserInfoDto";
import { ChangeProfileInputDto } from "../../dtos/user/ChangeProfileInputDto";
import { ChangePwdInput } from "../../dtos/user/ChangePwdDto";
import { CreateUserInputDto } from "../../dtos/user/CreateUserInputDto";
import { EmailDto } from "../../dtos/user/EmailDto";
import { GetAllUserInputDto } from "../../dtos/user/GetAllUserInputDto";
import { UpdateUserInputDto } from "../../dtos/user/UpdateUserInputDto";
import instance, { del, get, patch, post } from "../../utils/BaseService";

export async function changePwd(dispatch: any, input: ChangePwdInput) {
    return await patch(dispatch, '/user/changePassword', input, null)
}
export async function editProfile(dispatch: any, id: number, input: ChangeProfileInputDto) {
    return await patch(dispatch, '/user/editProfile', input, id)
}
export async function getUserByEmail(dispatch: any, input: EmailDto) {
    return await get(dispatch, '/user/getUserByEmail', input)
}
export async function getAllUsers(dispatch: any, input: GetAllUserInputDto) {
    return await get(dispatch, '/user/getAllUser', input)
}
export async function getUserById(dispatch: any, input:{id:number}) {
    return await get(dispatch, `/user/getUser/${input.id}`, null)
}
export async function createUser(dispatch: any, input: CreateUserInputDto ):Promise<{user:any,message:string}> {
    return await post(dispatch, '/user/createuser', input)   
}
export async function updateUser(dispatch: any, id: number, input:UpdateUserInputDto) {
    return await patch(dispatch, '/user/updateUser', input, id)
}
export async function deleteUser(dispatch: any, id: number) {
    return await del(dispatch, '/user/deleteUser',id)
}
export async function getCurrentUserLoginInfo(dispatch: any) {
    return await get(dispatch, '/user/getCurrentUserLoginInfo', null);
}
export async function getUserByTenantAndUserId(dispatch: any,input:GetUserInfoDto) {
    return await get(dispatch, '/user/getUserByTenantAndUserId', input);
}
